import React from 'react'
import Fade from 'react-reveal/Fade'
import { pages } from './data'
import { MagazinePages } from '../../components'
import { Blast } from '../../components'
import './magazine.scss'

const MagaPage = () => {
  const [letterClass, setLetterClass] = React.useState('text-animate')
  React.useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <>
    
    <section className="section__magazine">
    <div className="fake-big" style={{left:'30%'}}>Magazine</div>
        <h2 aria-label="My projects" className="section__magazine-title">
          <Blast
            letterClass={letterClass}
            arrayStr={['A','b','h','i','s','h','a','r',' ','v','1','2','.','0','-','v','1','3','.','0']}
            indexLetter={12}
          />
        </h2>
        <div className="section__magazine-description" style={{maxWidth:"700px"}}>
          <Fade bottom>
            <p>
            "Abhishar", the annual magazine of IIIT Gwalior, is a repository of articles contributed by students, alumni, and faculty, serving as a conduit for the exchange of diverse thoughts and experiences. It encapsulates the essence of institute happenings and offers insights into techno-managerial subjects.
            </p>
          </Fade>
          <Fade left>
                <a href="https://www.aasf.in/abhishar" className="contact-button">
                <div>
                    <span className='bg switch__bg'></span>
                    <span className='base switch__border-color'></span>
                    <span className='text'>Abhishar versions</span>
                  </div>
                </a>
                </Fade>
          <Fade bottom>
            <p>
          Having been afforded the privilege to contribute to "Abhishar," I directed my artistic mindset and graphic design skills toward four principal pages, infusing them with visual appeal and narrative depth. This experience was not just about participation; it was an avenue for me to express creativity and contribute to the vibrant tapestry of voices within the magazine. The four main pages on which I have worked on:
              
            </p>
          </Fade>
        </div>
        <div className="section__magazine-wrapper">
        {pages.map((project, index) => {
        return <MagazinePages {...project} key={index} 
        />})}
        </div>
    </section>
    </>
  )
}

// export default ProjectPage




export default MagaPage
